import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useFeatureServices, useTrackingManager } from 'src/feature-app';
import { DpsData, EsOneformCoreServiceV1 } from 'src/feature-service/es-oneform-core-feature-service/types';
import { CarlineBase, DealersData, IdLead, IdPerson } from 'src/types';
import { NoCompraYaTengo, NoCompraNoTengo, NoCompraNoQuiero } from '.';
import { GenericErrorLayer } from 'src/components/layers';
import { checkHasCarline } from './use-initialize-no-compra-form';
import { createPincodeEntity } from '../dps-utils';
import { Loading } from 'src/components';

export interface NoCompraFormProps {
  idLead: IdLead;
  idPerson: IdPerson;
  dpsData: DpsData;
  handleError: () => void;
  trackFormLoad: () => void;
  estado: string;
}

export function NoCompraController() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [usado, setUsado] = useState(false);
  const [estado, setEstado] = useState(null);
  const [yaTengo, setYaTengo] = useState(false);
  const [noTengo, setNoTengo] = useState(false);
  const [noQuiero, setNoQuiero] = useState(false);
  const trackingManager = useTrackingManager();
  const dpsDataRef = useRef(null);
  const idLeadRef = useRef(null);
  const idPersonRef = useRef(null);
  const oneFormService = useFeatureServices()['es:oneform-core'] as EsOneformCoreServiceV1;
  const dispatch = useDispatch();

  const handleNext = (value: any) => { };
  const handleComplete = () => {
    const dpsData = oneFormService.getDpsData();
    const { estado } = dpsData;
    setEstado(estado);

    if (dpsData.pincode === null || dpsData.pincode.noPincodeFound || dpsData.pincode.pincodeError) {
      handleError();
    } else if (dpsData.pincode.pincodeUsed) {
      setUsado(true);
      setLoading(false);
    } else {
      const idLead = createPincodeEntity(dpsData, 'LEAD');
      const idPerson = createPincodeEntity(dpsData, 'PERSON');

      dpsDataRef.current = dpsData;
      idLeadRef.current = idLead;
      idPersonRef.current = idPerson;

      if (estado === 'ya_tengo') {
        setYaTengo(true);
      } else if (estado === 'no_quiero') {
        setNoQuiero(true);
      } else if (estado === 'no_tengo') {
        setNoTengo(true);
      } else {
        handleError();
      }
      setLoading(false);
    }
  };

  const handleError = () => {
    setError(true);
    setLoading(false);
  };

  {/* useEffect(() => {
    console.log(error, 'error');
  }, [error]);*/}

  const trackFormLoad = () => {
    if (idLeadRef.current) {
      const customDealer: DealersData = {
        kvps: idLeadRef.current.TXT_DESC_DEALER_CODE__c,
        name: idLeadRef.current.DESC_Dealer_Code__c,
        markerInfo: { dealerInfo: { zipCode: idLeadRef.current.TXT_Postal_Code__c } },
      };
      dispatch({ type: 'SET_SELECTED_DEALER', payload: customDealer });
      if (checkHasCarline(idLeadRef.current)) {
        const carline: Partial<CarlineBase> = {
          title: idLeadRef.current.DESC_Model__c,
          code: Number(idLeadRef.current.NUM_COD_INTEREST_CARLINE__c),
        };
        dispatch({ type: 'SET_SELECTED_CARLINE', payload: carline });
      }
    }
    trackingManager.trackFormLoad();
  };

  useEffect(() => {
    const oneFormCoreDpsIsLoaded = oneFormService.getLoadedState();

    oneFormCoreDpsIsLoaded.subscribe({
      next(value) {
        handleNext(value);
      },
      error(err) {
        console.error(err);
        handleError();
      },
      complete() {
        handleComplete();
      },
    });
  }, []);

  // función para layer de error
  const handleTryAgain = async () => {
    // oneFormService.
    setError(false);
    setLoading(true);
    await oneFormService.retryPincodeLoad();
    handleComplete();
  };

  if (loading) {
    return <Loading />;
  } else if (error) {
    return (
      <>
        <GenericErrorLayer
          title="Uy, algo ha pasado"
          bodycopy="Por alguna razón no hemos podido cargar este cuestionario."
          ctaLayer="Reintentar"
          notShowCTA={true}
          icon={false}
          notALayer={true}
        />
      </>
    );
  } else if (usado) {
    return (
      <>
        <GenericErrorLayer
          title="Uy, ya has respondido a este cuestionario"
          bodycopy="Parece que ya has compartido tu opinión con nosotros. ¿Quieres añadir algo más?"
          ctaLayer="Contacta con nosotros"
          ctaType="a"
          urlHref="https://formulario.volkswagen.es/sac?formid=vw-sac"
          icon={false}
          notALayer={true}
        />
      </>
    );
  } else {
    return (
      <>
        {yaTengo ? (
          <NoCompraYaTengo
            dpsData={dpsDataRef.current}
            idLead={idLeadRef.current}
            idPerson={idPersonRef.current}
            handleError={handleError}
            trackFormLoad={trackFormLoad}
            estado={estado}
          />
        ) : noTengo ? (
          <NoCompraNoTengo
            dpsData={dpsDataRef.current}
            idLead={idLeadRef.current}
            idPerson={idPersonRef.current}
            handleError={handleError}
            trackFormLoad={trackFormLoad}
            estado={estado}
          />
        ) : noQuiero ? (
          <NoCompraNoQuiero
            dpsData={dpsDataRef.current}
            idLead={idLeadRef.current}
            idPerson={idPersonRef.current}
            handleError={handleError}
            trackFormLoad={trackFormLoad}
            estado={estado}
          />
        ) : null}
      </>
    );
  }
}
